import React from 'react';

import MuiInputAdornment, {
  InputAdornmentProps as MuiInputAdornmentProps,
} from '@mui/material/InputAdornment';
import clsx from 'clsx';

import { CoreProps } from '../types';
import { withCoreProps } from '../withCoreProps';

export const InputAdornment = withCoreProps<InputAdornmentProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<InputAdornmentProps>) => {
    const clsxClass = clsx(className);

    return (
      <MuiInputAdornment {...props} className={clsxClass}>
        {children}
      </MuiInputAdornment>
    );
  },
);

export interface InputAdornmentProps
  extends MuiInputAdornmentProps,
    CoreProps {}
